"use strict";Object.defineProperty(exports,"__esModule",{value:!0});const e=require("../../../node_modules/graphql-tag/lib/index.js").gql`
    mutation patchCorpCollection(
        $collection: CorpCollectionPatch!
        $collectionId: Int!
    ) {
        updateCorpCollection(
            input: { patch: $collection, corpCollectionId: $collectionId }
        ) {
            corpCollection {
                id: corpCollectionId
                label
                models {
                    lineDescription
                    brandAcronym
                    hasVirtualTour
                    floorPlanReference
                    tags
                    images {
                        mfgModelImageId
                        modelsImagesId
                        modelId
                        isInspired
                        createdBy
                        creationDate
                        lastModifiedBy
                        lastModificationDate
                        isMhAdvantageHome
                        imageId
                        reference
                        caption
                        sortOrder
                        originalUploadedFilename
                        imageType
                        imageTypeAcronym
                        roomId
                        roomDescription
                    }
                    virtualTours {
                        mfgModelVirtualTourId
                        modelId
                        virtualTourId
                        virtualTourReference
                        thumbnailReference
                    }
                    dealers
                    modelId
                    modelNumber
                    modelDescription
                    modelWidth
                    modelLength
                    beds
                    baths
                    maxSquareFeet
                    lowPrice
                    highPrice
                    hasIfp
                    hasDreamHomeDesign
                    startingInThePrice
                    isMhAdvantageHome
                    isPremierFinancingEligible
                }
            }
        }
    }
`;exports.patchCorpCollection=e;
//# sourceMappingURL=queries.js.map
